"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.SelectMultiItem = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../../i18n");
var styles_1 = require("../../../styles");
var TimesDefault_1 = __importDefault(require("../../Icon/generated/TimesDefault"));
function SelectMultiItem(props) {
    var style = props.style, children = props.children, onRemove = props.onRemove, disabled = props.disabled, rest = __rest(props, ["style", "children", "onRemove", "disabled"]);
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("span", __assign({ className: css(classes.root, style) }, rest),
        react_1.default.createElement("span", { className: classes.text }, children),
        !disabled && (react_1.default.createElement("span", { className: classes.button, onClick: onRemove, title: locale.select.removeItem },
            react_1.default.createElement(TimesDefault_1.default, null)))));
}
exports.SelectMultiItem = SelectMultiItem;
exports.createStyles = function (theme, _a) {
    var disabled = _a.disabled;
    return ({
        root: {
            border: "1px solid " + theme.pallete.divider,
            borderRadius: theme.radius.button,
            display: 'inline-flex',
            alignItems: 'center',
            fontWeight: 'bold',
        },
        text: {
            padding: disabled ? 'calc(0.25rem - 1px) 0.25rem' : 'calc(0.125rem - 1px) 0.25rem',
        },
        button: {
            background: theme.pallete.surface.background,
            cursor: 'pointer',
            fontSize: '1.25rem',
            display: 'inline-flex',
            alignItems: 'center',
            padding: 'calc(0.125rem - 1px) 0',
            '&:hover': {
                color: theme.pallete.status.danger.main,
            },
            svg: {
                fill: 'currentColor',
            },
        },
    });
};
//# sourceMappingURL=SelectMultiItem.js.map